<template>
  <div class="ma-4">
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="text-h4 mb-6" v-show="!showSkeleton">Atualizar Agendamento - {{ description }}</div>
    <AbaAgendamentoData v-if="canRender && tipo === 'data'" :_id="_id" />
    <AbaAgendamentoAno v-if="canRender && tipo === 'anual'" :_id="_id" />
    <AbaAgendamentoMes v-if="canRender && tipo === 'mensal'" :_id="_id" />
    <AbaAgendamentoSemana v-if="canRender && tipo === 'semanal'" :_id="_id" />
    <AbaAgendamentoHora v-if="canRender && tipo === 'hora'" :_id="_id" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import AbaAgendamentoHora from '../_components/AbaAgendamentoHora'
import AbaAgendamentoSemana from '../_components/AbaAgendamentoSemana'
import AbaAgendamentoMes from '../_components/AbaAgendamentoMes'
import AbaAgendamentoData from '../_components/AbaAgendamentoData'
import AbaAgendamentoAno from '../_components/AbaAgendamentoAno'
import agentamentosStore from '../_store'

export default {
  name: 'AtualizarAgendamento',
  props: {
    _id: String,
  },
  components: {
    AbaAgendamentoHora,
    AbaAgendamentoSemana,
    AbaAgendamentoMes,
    AbaAgendamentoData,
    AbaAgendamentoAno,
    SkeletonLoaderTitleUpdate,
  },

  data: () => ({
    tipo: '',
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarAgendamentoModulePABXStore', ['getagendamentoSelecionado']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarAgendamentoModulePABXStore', agentamentosStore)

    await this.selecionarAgendamento(this._id)

    this.tipo = this.getagendamentoSelecionado.tipo
    this.description = this.getagendamentoSelecionado.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarAgendamentoModulePABXStore', ['selecionarAgendamento']),
  },
}
</script>
